import { Button, Tooltip } from "antd";
import { DeleteSvg } from "./svg";
import { useAppStore } from "../../store/store";

const DeleteBtn = ({
  action,
  className,
  disabled,
}: {
  action: () => void;
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <Tooltip
      title={disabled ? "Unlik customer device(s) first" : ""}
      placement="bottomLeft"
    >
      <Button
        type="text"
        htmlType="button"
        icon={<DeleteSvg className="" />}
        disabled={disabled}
        onClick={() => {
          action();
        }}
        className={`Nunito w-fit h-[42px] ${className} flex items-center justify-center bg-white hover:!bg-white !text-[#6B7280] hover:!text-[#6B7280] hover:opacity-[0.8] font-[400] text-[12px] 2xl:text-[14px] !border-[#D0D5DD] !border-[1px] rounded-[8px] cursor-pointer  `}
        loading={false}
      >
        <p className="hidden md:block">Delete</p>
      </Button>
    </Tooltip>
  );
};

export default DeleteBtn;
